import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";

export default function AdminDashboard() {
  const [counts, setCounts] = useState({
    members: null,
    cmsRows: null,
    events: null,
  });

  useEffect(() => {
    if (!isSupabaseConfigured || !supabase) return;

    (async () => {
      const [{ count: mc }, { count: cc }, { count: ec }] = await Promise.all([
        supabase.from("profiles").select("id", { count: "exact", head: true }),
        supabase
          .from("cms_site_content")
          .select("id", { count: "exact", head: true }),
        supabase.from("events").select("id", { count: "exact", head: true }),
      ]);
      setCounts({
        members: mc ?? 0,
        cmsRows: cc ?? 0,
        events: ec ?? 0,
      });
    })();
  }, []);

  return (
    <div>
      <h1 className="h3 mb-4">Dashboard</h1>
      <p className="text-muted">
        Manage members, events, CMS content, and images from the menu.
      </p>

      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h2 className="h5 card-title">Members</h2>
              <p className="display-6 mb-0">
                {counts.members === null ? "—" : counts.members}
              </p>
              <Link to="/admin/members" className="small">
                Open list →
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h2 className="h5 card-title">CMS sections saved</h2>
              <p className="display-6 mb-0">
                {counts.cmsRows === null ? "—" : counts.cmsRows}
              </p>
              <Link to="/admin/cms" className="small">
                Edit content →
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h2 className="h5 card-title">Events</h2>
              <p className="display-6 mb-0">
                {counts.events === null ? "—" : counts.events}
              </p>
              <Link to="/admin/events" className="small">
                Manage events →
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h2 className="h5 card-title">Images</h2>
              <p className="text-muted small mb-2">
                Supabase Storage bucket <code>site-images</code>
              </p>
              <Link to="/admin/images" className="small">
                Manage uploads →
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="alert alert-secondary small mb-0">
        First-time setup: run <code>supabase/schema.sql</code> and{" "}
        <code>supabase/events_and_invitations.sql</code>, then promote your user with:
        <code className="d-block mt-2">
          update public.profiles set is_admin = true where email =
          &apos;your@email.com&apos;;
        </code>
      </div>
    </div>
  );
}
